import React, { useState, useEffect } from "react";
import "../ProductSpecificAgreement.modules.css";

import { useTranslation } from "react-i18next";
import i18next from "i18next";
import * as Constants from "../../../../../constants/Constants";

const TAndC = (props) => {
  const { t } = useTranslation();
  useEffect(() => {
    ;
    if (props.IsCallAPI) {
      props.setIsCallAPI(false);
      saveKycDataFun();
      props.handleNext();
    }
  }, [props.IsCallAPI]);

  const saveKycDataFun = () => {
    var Items = [
      { ID: "312", Value: "Y" },
      { ID: "258", Value: "2" },
    ];
    props.saveKycDataAPI(Items);
  };
  return (
    <div className="ProductSpecificAgreement-container">
      <div className="progress-bar"></div>

      <h2>{t("AcceptTermsandConditions")}</h2>
      <label>{t("Kindlyreviewandacceptindividualagreements")}</label>
      {i18next.language === "ar" ? (
        <div
          className="agreements-container"
          style={{ overflow: "auto", height: "70%" }}
        >
          <p>
            2. إذا رغب أحد الطرفين في إنهاء هذه الاتفاقية، شريطة أن يقوم الطرف
            الراغب في الإنهاء بإرسال إشعار كتابي للطرف الآخر قبل خمسة أيام على
            الأقل من تاريخ الإنهاء المقصود، مع الوفاء بجميع الحقوق والالتزامات
            الناشئة عند تنفيذ الاتفاقية.
          </p>

          <p>
            3. إذا انتهك العميل أيًا من التزاماته بموجب هذه الاتفاقية ولم يقم
            بإصلاح هذا العيب خلال مدة أقصاها (5) أيام عمل، يجوز للشركة إنهاء هذا
            العقد والمطالبة بجميع المبالغ المستحقة مع التأخير والأضرار وغرامة
            تأخير بنسبة 20% سنويًا من تاريخ الاستحقاق حتى السداد الكامل.
          </p>

          <p>
            4. في جميع الأحوال، لن يؤثر إنهاء هذه الاتفاقية على أي حقوق أو
            التزامات ناشئة قبل هذا الإنهاء، ولا سيما فيما يتعلق بأي رسوم أو
            عمولات مستحقة للشركة، ولهذا الغرض ستظل الاتفاقية سارية المفعول بين
            الطرفين حتى يتم تسوية تلك الحقوق والالتزامات، وبعد ذلك تعتبر
            الاتفاقية منتهية دون الحاجة إلى أي إشعار قضائي أو إجراءات قانونية
            أخرى.
          </p>

          <p>
            <strong>المادة 13: التفسير وحل النزاعات</strong>
          </p>

          <p>
            يتم تفسير هذه الاتفاقية وجميع الحقوق والالتزامات الناتجة عنها وفقًا
            للقوانين واللوائح السارية في دولة الإمارات العربية المتحدة. يتم
            تسوية أي نزاع ينشأ بين الطرفين بالوسائل الودية. في حالة عدم توصل
            الطرفين إلى حل ودي خلال (7) أيام عمل، يتم تسوية هذا النزاع عن طريق
            المحاكم المختصة في دولة الإمارات العربية المتحدة. يوافق الطرفان بشكل
            نهائي على أن تكون محاكم أبوظبي لها الاختصاص للنظر في تنفيذ أي نزاع
            ينشأ عن أو يتعلق بهذه الاتفاقية.
          </p>

          {/* <div className='TAndCDiv'>
                <button className='rejectTC'>رفض</button>
                <button>قبول</button>
            </div> */}
        </div>
      ) : (
        <div
          className="agreements-container"
          style={{ overflow: "auto", height: "70%" }}
        >
          <p>
            2. If one of the Parties desires to terminate this Agreement,
            provided that the party wishing to terminate sends a notice in
            writing to the other party at least 5 days prior to the intended
            date of termination and fulfillment of all rights and obligations
            arising upon execution of the Agreement.
          </p>

          <p>
            3. If the Client violates any of its obligations under this
            agreement and does not repair this defect within a maximum of (5)
            working days, the Company may terminate this contract and claim for
            all due amounts with the delay and damage and the delay penalty at
            20% annually from maturity until full repayment.
          </p>

          <p>
            4. In all cases, termination of this Agreement shall not affect any
            rights and obligations arising prior to such termination, more
            particularly with respect to any fees or commissions due to the
            Company, and for such purpose the Agreement shall remain in full
            force and effect between the two parties until settlement of such
            rights and obligations after such time it shall be considered
            terminated without need for any court notice or other legal
            proceedings.
          </p>

          <p>
            <strong>Article 13: Interpretation & Solving Disputes</strong>
          </p>

          <p>
            This Agreement and all rights and obligations of the Parties
            resulting therefrom shall be construed in accordance with the laws
            and regulations in force in the United Arab Emirates. Any dispute
            arising between the parties here to shall be settled through
            amicable means. In case the parties do not reach an amicable
            solution within (7) working days, such dispute shall be settled by
            the competent courts in the UAE. The Parties irrevocably agree that
            the courts of Abu Dhabi shall have jurisdiction to determine the
            enforcement of, and any dispute arising out of or in connection with
            this Agreement.
          </p>

          {/* <div className='TAndCDiv'>
                    <button className='rejectTC'>Reject</button>
                    <button >Accept</button>
                </div> */}
        </div>
      )}
    </div>
  );
};

export default TAndC;
